<template>
    <div class="about">
        <Header></Header>
        <div class="main-about">
            <div class="nav-banner">
                <div class="box">
                    <div class="left">
                        <h2>金融机构数字化营销智囊团</h2>
                        <p>
                            用互联网思维开放创新，开创金融行业数字化营销新模式
                        </p>
                        <div>
                            <a @click="denglu" class="btn">立即试用</a>
                        </div>
                    </div>
                    <div class="right">
                        <img src="" alt="" />
                    </div>
                </div>
            </div>
            <div class="introduce">
                <div class="contain">
                    <h2>契合科技平台介绍</h2>
                    <div class="box">
                        <div class="item">
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/fengfu.png"
                                alt=""
                            />
                            <h3>丰富玩法</h3>
                            <p>多样营销玩法</p>
                            <p>快速响应业务需求</p>
                        </div>
                        <div class="item">
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/zhuanye.png"
                                alt=""
                            />
                            <h3>专业技术</h3>
                            <p>专业的技术团队</p>
                            <p>靠谱的技术实力</p>
                        </div>
                        <div class="item">
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/changjing.png"
                                alt=""
                            />
                            <h3>场景营销</h3>
                            <p>多场景多客群</p>
                            <p>有针对性开展营销</p>
                        </div>
                    </div>
                    <div class="introduce-text">沈阳契合科技有限公司自2015年起从事金融客户的服务与技术支撑工作，形成了完善的客户运营体系，具备全面的网络金融信息安全管理体系与能力。金融业服务经验丰富，产品业务布局合理，融合发展软件开发部署、私域运营服务和营销策划与执行，各个板块资源共享，协同经营。企业发展目标是成为“业内知名的私域运营与营销服务供应商”。</div>
                    <div class="introduce-text" style="margin-top: 0;">金融数字化营销整体解决方案服务商，私域运营体系制定及代运营专家，微信、支付宝平台授权服务商，优秀的数据与网络安全能力，成熟的商务、技术和运营团队，丰富的线上/线下场景资源。</div>
                </div>
            </div>
            <div class="usadvantage">
                <div class="contain">
                    <h2>我们的优势</h2>
                    <p class="subtitle">
                        我们有专业的团队以及优秀的产品平台，帮助客户高效运营海量用户，打造品牌特有的个性化用户体验，同时快速收获业务增长。
                    </p>
                    <div class="box">
                        <div class="left">
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/youshi_left.png"
                                alt=""
                            />
                        </div>
                        <div class="right">
                            <div class="item">
                                <p class="title">内容生产快</p>
                                <p class="p">
                                    创建H5只需 10 分钟，营销活动创建 30
                                    分钟，定制化活动两到三周完成。
                                </p>
                            </div>
                            <div class="item">
                                <p class="title">省时省人省钱</p>
                                <p class="p">
                                    活动、H5
                                    的设计均可用模版完成，定制活动研发时间缩短50%。
                                </p>
                            </div>
                            <div class="item">
                                <p class="title">多样的解决方案</p>
                                <p class="p">
                                    灵活多样的组合解决方案，适用于金融机构的各大部门及业务场景。
                                </p>
                            </div>
                            <div class="item">
                                <p class="title">稳健的运营实施</p>
                                <p class="p">
                                    前端效果快速实现，中台化建设，稳健底层架构支撑，为客户提供可持续的运营支持。
                                </p>
                            </div>
                            <div class="item">
                                <p class="title">懂金融，懂营销</p>
                                <p class="p">
                                    契合科技专注于金融行业，已有丰富的营销项目成功经验，“懂金X懂营销”，契合科技帮助您完成数字化营销升级。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="usculture">
                <div class="contain">
                    <h2>我们努力践行的文化</h2>
                    <div class="box">
                        <div>
                            <div class="item">
                                <div class="icon">
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/wenhua1.png"
                                        alt=""
                                    />
                                </div>
                                <div class="text">
                                    <h3>助力数字化经营</h3>
                                    <p>
                                        为客户营销提供数字化基础设施以及专业服务，助力客户完成的数字化运营的转型。
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="item">
                                <div class="icon">
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/wenhua2.png"
                                        alt=""
                                    />
                                </div>
                                <div class="text">
                                    <h3>帮助客户成功</h3>
                                    <p>
                                        使用我们的专业和技术，帮助客户完成运营目标。客户的成功，即我们的成功。
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="item">
                                <div class="icon">
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/wenhua3.png"
                                        alt=""
                                    />
                                </div>
                                <div class="text">
                                    <h3>敢于创新，稳健实施</h3>
                                    <p>
                                        在输出营销创意方案的同时，保证落地可行性，保证数据安全性。
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="box">
                        <div>
                            <div class="item">
                                <div class="icon">
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/wenhua4.png"
                                        alt=""
                                    />
                                </div>
                                <div class="text">
                                    <h3>打造一站式营销云</h3>
                                    <p>
                                        帮助客户完成在业务和产品各阶段的增长难题，提供全链路的运营服务。
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="item">
                                <div class="icon">
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/wenhua5.png"
                                        alt=""
                                    />
                                </div>
                                <div class="text">
                                    <h3>让增长更简单</h3>
                                    <p>
                                        帮助客户完成在业务和产品各阶段的增长难题，提供全链路的运营服务。
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="item">
                                <div class="icon">
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/wenhua6.png"
                                        alt=""
                                    />
                                </div>
                                <div class="text">
                                    <h3>成为值得信赖的营销伙伴</h3>
                                    <p>
                                        对客户、合作伙伴充满热情，成为他们营销上坚实可靠的智囊团及友好伙伴。
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="text1">
                        契合科技致力推动因金融业全面拥抱互联网，提升各级金融机构的运营效率，降低运营成本，带动运营的全面更新。<br />
                        契合科技更懂金融：深入了解金融业各级机构的运营场景，深刻理解需求表象和需求背后的商业价值逻辑，<br />
                        针对金融业推出一揽子运营产品及解决方案。不仅满足表象需求，也引领银行业运营模式的变化。
                    </div>
                    <div class="text2">
                        契合科技用“人才+方法+工具+平台+数据+创意”的方式，改变以往金融业运营项目的运作模式，<br />
                        让运营成本更低、管理更高效，让数字化运营能持续常态化开展。<br />
                        契合科技正在全面推动金融业，从数字化局部运营进化到数字化全面运营时代。
                    </div>
                </div>
            </div>
            <div class="contactus">
                <div class="contain">
                    <h2>联系我们</h2>
                    <div class="box1">
                        <div class="div1"></div>
                        <div class="div2">
                            <div class="item">
                                <div class="top">
                                    <p class="name1">
                                        <span>
                                            <img
                                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/tel.png"
                                                alt=""
                                            />
                                        </span>
                                        合作咨询电话：
                                    </p>
                                    <p>400-000-5560</p>
                                </div>
                            </div>
                        </div>
                        <div class="div3"></div>
                        <div class="div4">
                            <div class="item">
                                <div class="top">
                                    <p class="name1">
                                        <span>
                                            <img
                                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/email.png"
                                                alt=""
                                            />
                                        </span>
                                        商务合作：
                                    </p>
                                    <p>service@qihe-cloud.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="box">
                        <div class="item">
                            <div class="icon">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/beijing.png"
                                    alt=""
                                />
                            </div>
                            <h3>北京总部</h3>
                            <p class="address">
                                北京市朝阳区望京 SOHO - T1 - B 座 910
                            </p>
                        </div>
                        <div class="item">
                            <div class="icon">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/guangzhou.png"
                                    alt=""
                                />
                            </div>
                            <h3>广州分公司</h3>
                            <p class="address">
                                广州市天河区华夏路16号富力盈凯广场1309室
                            </p>
                        </div>
                        <div class="item">
                            <div class="icon">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/shenyang.png"
                                    alt=""
                                />
                            </div>
                            <h3>沈阳分公司</h3>
                            <p class="address">
                                辽宁省沈阳市浑南新区沈阳国际软件园 E07D 户 4 楼
                            </p>
                        </div>
                        <div class="item">
                            <div class="icon">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/wuhan.png"
                                    alt=""
                                />
                            </div>
                            <h3>武汉分公司</h3>
                            <p class="address">
                                武汉市东湖高新区关山大道光谷软件园 D8 栋
                            </p>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="footer">
            <bgred></bgred>
            <contain></contain>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header1";
import bgred from "../../components/bgred.vue";
import contain from "../../components/contain.vue";
export default {
    components: {
        Header,
        bgred,
        contain,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        denglu() {
            this.$router.push({
                path: "/login",
            });
        },
    },
};
</script>

<style scoped>
h2,
h3,
h4,
h5,
p {
    padding: 0;
    margin: 0;
    font-size: 16px;
    font-weight: 400;
}
.nav-banner {
    width: 100%;
    height: 505px;
    background: linear-gradient(221deg, #3060eb, #2970eb);
}
.nav-banner .box {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    background: url('../../assets/aboutus_ban.png')
        100% 100% no-repeat;
    background-size: 651px auto;
}
.nav-banner .box .left {
    text-align: left;
}
.nav-banner .box .left h2 {
    padding-top: 145px;
    font-size: 44px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #fff;
    line-height: 44px;
}
.nav-banner .box .left p {
    padding-top: 30px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #fff;
    line-height: 20px;
}
.nav-banner .box .left .btn {
    display: block;
    margin-top: 52px;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    line-height: 57px;
    width: 162px;
    height: 57px;
    background: hsla(0, 0%, 100%, 0);
    border-radius: 4px;
    border: 1px solid hsla(0, 0%, 100%, 0.7);
    box-sizing: border-box;
}
.main-about .introduce {
    background: #fff;
    text-align: center;
    padding: 80px 0 125px;
    box-sizing: border-box;
}
.main-about .introduce .contain {
    width: 1010px;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}
.main-about .introduce h2 {
    margin-bottom: 60px;
}
.main-about h2 {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #595961;
    line-height: 32px;
}
.main-about .introduce .box {
    display: flex;
}
.main-about .introduce .box .item {
    flex: 1;
}
.main-about .introduce .box .item .icon {
    width: 60px;
    height: 60px;
}
.main-about .introduce .box .item h3 {
    margin: 35px 0 8px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #595961;
    line-height: 24px;
}
.main-about .introduce .box .item p {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999;
    line-height: 26px;
}
.main-about .introduce .introduce-text {
    text-align: left;
    margin-top: 54px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #595961;
    line-height: 40px;
    text-indent: 2em;
    white-space: pre-line;
}
.main-about .usadvantage {
    padding: 80px 0 20px;
    background: #f8f8f8;
}
.main-about .usadvantage .subtitle {
    padding-top: 24px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #838387;
    line-height: 18px;
}
.main-about .usadvantage .box {
    display: flex;
    padding-top: 98px;
}
.main-about .usadvantage .box .left {
    width: 492px;
    height: 492px;
    margin-right: 70px;
}
.main-about .usadvantage .box .left img {
    width: 488px;
}
.main-about .usadvantage .box .right {
    text-align: left;
    flex: 1;
}
.main-about .usadvantage .box .right .title {
    font-size: 20px;
    color: #595961;
    line-height: 20px;
}
.main-about .usadvantage .box .right .p {
    margin: 17px auto 55px;
    font-size: 16px;
    color: #999;
    line-height: 20px;
}
.main-about .usculture {
    background: #fff;
    text-align: center;
    padding: 80px 0 105px;
    box-sizing: border-box;
}
.main-about .usculture h2 {
    margin-bottom: 64px;
}
.main-about .usculture .box {
    display: flex;
    margin-bottom: 12px;
}
.main-about .usculture .box .item {
    width: 370px;
    flex: 1;
    box-sizing: border-box;
    padding: 28px 12px 28px 23px;
    background: #fff;
    box-shadow: 0 2px 11px 0 hsl(0deg 0% 80% / 39%);
    border-radius: 8px;
    display: flex;
    margin: 0 12px;
}
.main-about .usculture .box .item .icon {
    margin-right: 26px;
    width: 44px;
    height: 44px;
}
.main-about .usculture .box .item .icon img {
    width: 44px;
}
.main-about .usculture .box .item .text {
    text-align: left;
}
.main-about .usculture .box .item .text h3 {
    margin-bottom: 6px;
    font-size: 20px;
    color: #595961;
    line-height: 20px;
}
.main-about .usculture .box .item .text p {
    font-size: 14px;
    color: #999;
    line-height: 21px;
}
.main-about .usculture .text1,
.main-about .usculture .text2 {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6d6d74;
    line-height: 32px;
}
.main-about .usculture .text1 {
    margin: 59px auto 32px;
}
.main-about .contactus {
    text-align: center;
    padding: 80px 0 124px;
    box-sizing: border-box;
    background: url(https://ccbhdimg.kerlala.com/hd/website/urthink/contactus_bg.png)
        no-repeat;
}
.main-about .contactus h2 {
    margin-bottom: 59px;
}
.main-about .contactus .box1 {
    display: flex;
    justify-content: space-around;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    width: 616px;
    margin: 0 auto;
    color: #595961;
    line-height: 24px;
}
.main-about .contactus .box1 .div1 {
    display: none;
}
.main-about .contactus .box1 .top {
    text-align: left;
    margin-bottom: 100px;
}
.main-about .contactus .box1 .name1 {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    opacity: 0.6;
    color: #595961;
    line-height: 16px;
    margin-bottom: 8px;
}
.main-about .contactus .box1 .name1 span img {
    width: 18px;
    margin-right: 2px;
}
.main-about .contactus .box {
    display: flex;
    justify-content: space-around;
    width: 1142px;
    margin: 0 auto;
}
.main-about .contactus .box .item {
    width: 250px;
    text-align: left;
}
.main-about .contactus .box .item .icon {
    margin-bottom: 23px;
}
.main-about .contactus .box .item .icon img {
    width: 250px;
}
.main-about .contactus .box .item h3 {
    margin-bottom: 13px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #595961;
    line-height: 20px;
}
.main-about .contactus .box .item .adress {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #595961;
    line-height: 28px;
}
</style>


// WEBPACK FOOTER //
// src/views/aoveras/about.vue